module.exports = __webpack_public_path__ + "static/img/eye.81f986ff.svg";